var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-tabs",
        [
          _c(
            "b-tab",
            { attrs: { active: "", title: "Ticket Info" } },
            [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.loading
                ? _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Ticket Number",
                                    "label-for": "ticket_number",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "ticket_number",
                                      type: "text",
                                      placeholder: "Ticket Number",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.ticketId.reference,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ticketId, "reference", $$v)
                                      },
                                      expression: "ticketId.reference",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Customer",
                                    "label-for": "h-Customer-Id",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "customer",
                                      type: "text",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.customerName,
                                      callback: function ($$v) {
                                        _vm.customerName = $$v
                                      },
                                      expression: "customerName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Title",
                                    "label-for": "title",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "title",
                                      type: "text",
                                      placeholder: "Title",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.ticketId.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ticketId, "name", $$v)
                                      },
                                      expression: "ticketId.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Category",
                                    "label-for": "category",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.optionsCategory,
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.ticketId.category,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ticketId, "category", $$v)
                                      },
                                      expression: "ticketId.category",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Products / Services",
                                    "label-for": "Product",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "product",
                                      type: "text",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.productName,
                                      callback: function ($$v) {
                                        _vm.productName = $$v
                                      },
                                      expression: "productName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Description",
                                    "label-for": "h-Description",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-textarea", {
                                    staticClass: "mb-2 mb-lg-0",
                                    attrs: { id: "description", readonly: "" },
                                    model: {
                                      value: _vm.ticketId.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ticketId,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "ticketId.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Assigned To",
                                    "label-for": "assigned",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "assigned",
                                      type: "text",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.assignedToName,
                                      callback: function ($$v) {
                                        _vm.assignedToName = $$v
                                      },
                                      expression: "assignedToName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Status",
                                    "label-for": "status",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.statusOptions,
                                      disabled: _vm.isStatusClosed,
                                    },
                                    model: {
                                      value: _vm.ticketId.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ticketId, "status", $$v)
                                      },
                                      expression: "ticketId.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Priority",
                                    "label-for": "priority",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.options,
                                      disabled: _vm.isStatusClosed,
                                    },
                                    model: {
                                      value: _vm.ticketId.priority,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ticketId, "priority", $$v)
                                      },
                                      expression: "ticketId.priority",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Due Date",
                                    "label-for": "due_date",
                                    "label-cols-md": "4",
                                  },
                                },
                                [
                                  _c("b-form-datepicker", {
                                    attrs: {
                                      id: "due_date",
                                      disabled: _vm.isStatusClosed,
                                    },
                                    model: {
                                      value: _vm.ticketId.dueDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ticketId, "dueDate", $$v)
                                      },
                                      expression: "ticketId.dueDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { "offset-md": "4" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  staticClass: "mr-1",
                                  attrs: { type: "submit", variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitTicket()
                                    },
                                  },
                                },
                                [_vm._v(" Submit ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Comment History" } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end" },
                      [
                        _c(
                          "b-modal",
                          {
                            ref: "addcommentModal",
                            attrs: {
                              id: "modal-add-comment",
                              "ok-only": "",
                              "ok-title": "Add",
                              centered: "",
                              size: "lg",
                              title: "Add Comment",
                              "hide-footer": true,
                            },
                          },
                          [
                            _c("AddComment", {
                              attrs: { ticketId: _vm.id },
                              on: { "add-comment": _vm.addComment },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-add-comment",
                                modifiers: { "modal-add-comment": true },
                              },
                            ],
                            attrs: { variant: "primary" },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "PlusIcon" },
                            }),
                            _vm._v(" Add Comment "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "justify-content-between" },
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Filter",
                            "label-cols-sm": "3",
                            "label-align-sm": "right",
                            "label-size": "sm",
                            "label-for": "filterInput",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "filterInput",
                                  type: "search",
                                  placeholder: "Type to Search",
                                },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { disabled: !_vm.filter },
                                      on: {
                                        click: function ($event) {
                                          _vm.filter = ""
                                        },
                                      },
                                    },
                                    [_vm._v(" Clear ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-center mb-1",
                      attrs: { cols: "12" },
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: {
                              variant: "success",
                              label: "Spinning",
                              block: "",
                            },
                          })
                        : _c("b-table", {
                            attrs: {
                              striped: "",
                              hover: "",
                              responsive: "",
                              "per-page": _vm.perPage,
                              "current-page": _vm.currentPage,
                              items: _vm.items,
                              fields: _vm.fields,
                              filter: _vm.filter,
                              "filter-included-fields": _vm.filterOn,
                            },
                            on: { filtered: _vm.onFiltered },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(comment)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(data.item.comment) + " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(addedOn)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDate(data.item.createdOn)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(actions)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass: "m-1",
                                        attrs: {
                                          variant: "link",
                                          "toggle-class": "p-0",
                                          "no-caret": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function () {
                                                return [
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "align-middle text-body",
                                                    attrs: {
                                                      icon: "MoreVerticalIcon",
                                                      size: "16",
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "b-dropdown-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeComment(
                                                  data.item.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: { icon: "TrashIcon" },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "align-middle ml-50",
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }